<template lang="pug">
  form(ref="dialogForm", novalidate)
    app-modal(type="default", v-model="value.isOpen", :height="610", data-testid="sel-tag-modal")
      template(slot="title")
        template(v-if="value.mode.isEdit") タグの変更
        template(v-else) タグの選択

      app-messages(:errorMessages="errors")

      .modal-layout
        ul.nav.nav-tabs
          li.active.___jbcard-tag-public-tab
            a(href="#mgtags", data-toggle="tab" data-testid="-tab-mgtag") タグ
          li.___jbcard-tag-private-tab(v-if="value.mode.isDispPv")
            a(href="#pvtags", data-toggle="tab" data-testid="-tab-pvtag") 個人タグ

        .tab-content
          //- 共有タグ
          .tab-pane.active#mgtags
            .modal-list-target
              app-pagination(:is-loading="tags.loadingPagination", :pagination="tags.pagination", :useScrollTop="false", @change="getMgTagList")

              table.table.table-bordered.bcard-table
                thead
                  tr
                    th.bcard-table-td-chk
                      a(href="#" @click.prevent="selTagsAll('tags')" title="すべて追加")
                        i.fa.fa-fw.fa-angle-double-down
                    th 名称

              loading(v-if="tags.isLoading" :height="157")

              //- 1件以上ある場合
              .table-responsive(v-else-if="tags.data.length > 0")
                table.table.table-bordered.bcard-table
                  tbody
                    tr(v-for="(item, index) in tags.data", :key="item.id", :class="{active: isIncludes(selids_beta, item.id)}")
                      td.bcard-table-td-chk
                        a(href='#', title='追加', @click.prevent="selTag(item)")
                          i.fa.fa-fw.fa-arrow-down
                      td.bcard-ui-userdata(:title="item.name")
                        tag-color(:rgb="item.color_rgb", :outline="getOutline(item)")
                        | {{item.name}}

              //- 0件の場合
              .panel-body.text-center(v-else) タグ情報はありません。

          //- 個人タグ
          .tab-pane#pvtags
            .modal-list-target
              .bcard-btnbar.clearfix
                app-pagination(:is-loading="pvTags.loadingPagination", :pagination="pvTags.pagination", :useScrollTop="false", @change="getPvTagList")
                  template(slot="left")
                    router-link(v-if="value.mode.canAddPv", :to="{name: 'pvtag', params: {init: true}}", target="_blank")
                      | 個人タグ管理
                      |
                      |
                      i.fa.fa-external-link

              //- タグを追加
              .form-group(v-if="value.mode.canAddPv", @keypress.enter.prevent="addPvTag")
                .input-group
                  span.input-group-btn
                    button.btn.btn-default.dropdown-toggle(type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false")
                      span
                        tag-color(:rgb="pvTags.selected.color_rgb", :outline="getOutline(pvTags.selected)")
                        | &nbsp;
                        span.caret
                    ul.dropdown-menu
                      li(v-for="(color, index) in pvTags.colors", :key="color.id" :class="{active: pvTags.selected.color === color.id}" @click="selectColor(color)")
                        tag-color(:rgb="color.rgb", :outline="getOutline(color)")
                  //- 入力必須
                  input.form-control(v-model="pvTags.selected.name" type="text" required placeholder="タグ名", :maxlength="maxlengths.name", autocomplete="nope")
                  span.input-group-btn
                    button.btn.btn-success(type="button" @click.prevent="addPvTag")
                      i.fa.fa-plus.fa-fw
                      | 追加

              table.table.table-bordered.bcard-table
                thead
                  tr
                    th.bcard-table-td-chk
                      a(href="#" @click.prevent="selTagsAll('pvTags')" title="すべて追加")
                        i.fa.fa-fw.fa-angle-double-down
                    th 名称

              loading(v-if="pvTags.isLoading" :height="157")

              //- 1件以上ある場合
              .table-responsive(v-else-if="pvTags.data.length > 0")
                table.table.table-bordered.bcard-table
                  tbody
                    tr(v-for="(item, index) in pvTags.data", :key="item.id", :class="{active: isIncludes(selids_beta, item.id)}")
                      td.bcard-table-td-chk
                        a(href='#', title='追加', @click.prevent="selTag(item)")
                          i.fa.fa-fw.fa-arrow-down
                      td.bcard-ui-userdata(:title="item.name")
                        tag-color(:rgb="item.color_rgb", :outline="getOutline(item)")
                        | {{item.name}}

              //- 0件の場合
              .panel-body.text-center(v-else) タグ情報はありません。

        .modal-list-divider
        //- 選択済み一覧
        .modal-list-selected
          table.table.table-bordered.bcard-table
            thead
              tr
                th.bcard-table-td-chk
                  a(href='#', title='すべての選択を解除', @click.prevent="removeTagsAll")
                    i.fa.fa-fw.fa-times
                th 名称
          .table-responsive
            table.table.table-bordered.bcard-table
              tbody
                tr(v-for="(item, index) in seltags_beta", :key="item.id")
                  td.bcard-table-td-chk
                    a(href='#', title='解除', @click.prevent="removeTag(item)")
                      i.fa.fa-fw.fa-times
                  td.bcard-ui-userdata(:title="item.name")
                    tag-color(:rgb="item.color_rgb", :outline="getOutline(item)")
                    | {{item.name}}

      template(slot="footer", slot-scope="{close}")
        button.btn.btn-primary(type="button", @click="submit", data-testid="-btn-ok") {{value.mode.isEdit ? '変更' : 'OK'}}
        button.btn.btn-default(type="button", @click="close", data-testid="-btn-cancel") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import TagColor from '@/components/molecules/TagColor'
import Loading from '@/components/molecules/Loading'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const TagRepository = RepositoryFactory.get('tag')
const PvtagRepository = RepositoryFactory.get('pvtag')

export default {
  name: 'ModalSelTag',
  components: { AppModal, AppMessages, AppPagination, TagColor, Loading },
  mixins: [ mixinForm ],
  props: {
    /*
     * isOpen: 開閉状態
     * selectedIds: 選択IDs
     * selectedItems: 選択データ
     * mode:
     *   isDispPv: bool 個人タグ表示フラグ
     *   canAddPv: bool 個人タグ追加フラグ
     *   isEdit: bool 「変更」かどうか（文言の調整）
     */
    value: {
      type: Object,
      required: true,
      default: function () {
        return {
          isOpen: false,
          selectedIds: [],
          selectedItems: [],
          mode: {
            isDispPv: true,
            canAddPv: true,
            isEdit: false
          }
        }
      }
    },
    useSubmit: { type: Boolean, required: false, default: false }
  },
  data: function () {
    return {
      // 仮選択済みタグ
      seltags_beta: [],
      // 仮選択済みID
      selids_beta: [],
      tags: {
        data: [],
        pagination: {},
        isLoading: true,
        loadingPagination: true
      },
      pvTags: {
        data: [],
        pagination: {},
        isLoading: true,
        loadingPagination: true,
        colors: [],
        selected: {
          id: '',
          color: '',
          color_rgb: '',
          name: '',
          openflag: '0'
        }
      },
      maxlengths: {}
    }
  },
  watch: {
    'value.isOpen': function (newValue, oldValue) {
      // 開いたときの初期設定
      this.clearMessages()
      this.seltags_beta = []
      this.selids_beta = []
      if (newValue && !oldValue) {
        this.initModal()
        for (let item of this.value.selectedItems) {
          this.seltags_beta.push(item)
          this.selids_beta.push(item.id)
        }
      }
    }
  },
  mounted: function () {
    this.setDialogForm(this.$refs.dialogForm)
  },
  methods: {
    // タグ一覧取得
    getMgTagList: function (options) {
      options = options || {}

      this.getTagList({
        tags: this.tags,
        tagsType: 'm',
        page: options.page || 1,
        viaPagination: options.viaPagination || false
      })
    },
    // 個人タグ一覧取得
    getPvTagList: function (options) {
      options = options || {}

      this.getTagList({
        tags: this.pvTags,
        tagsType: 'p',
        page: options.page || 1,
        viaPagination: options.viaPagination || false
      })
    },
    /**
     * タグ一覧取得共通処理
     * @param object options
     *   tags: 対象タグオブジェクト
     *   tagsType: 対象タグの区分
     *   page: ページ番号
     *   viaPagination: pagination経由フラグ
     */
    getTagList: function (options) {
      const vm = this
      options.tags.isLoading = true
      options.tags.loadingPagination = !options.viaPagination

      TagRepository.getOptions(options.tagsType, options.page)
        .then(function (response) {
          options.tags.data = vm.getApiData(response).data
          options.tags.pagination = vm.getApiData(response).pagination
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          options.tags.isLoading = false
          options.tags.loadingPagination = false
        })
    },
    selTag: function (item) {
      const vm = this

      // すでに選択済みの場合、何もしない
      if (this.isIncludes(this.selids_beta, item.id)) {
        return
      }

      // 選択済みにする
      this.selids_beta.push(item.id)
      this.seltags_beta.push(item)

      // 表示順昇順にソートする
      this.seltags_beta.sort(function (a, b) {
        if (a.openflag === vm.app_flag.ON && a.openflag > b.openflag) {
          return -1
        }
        if (a.openflag === vm.app_flag.OFF && a.openflag < b.openflag) {
          return 1
        }
        if (a.seqno < b.seqno) {
          return -1
        }
        if (a.seqno > b.seqno) {
          return 1
        }
        return 0
      })
    },
    selTagsAll: function (tagType) {
      let tags = tagType === 'tags' ? this.tags.data : this.pvTags.data
      for (let item of tags) {
        this.selTag(item)
      }
    },
    removeTag: function (item) {
      // 選択を解除する
      this.selids_beta = this.selids_beta.filter(function (id) {
        return id !== item.id
      })

      this.seltags_beta = this.seltags_beta.filter(function (tag) {
        return tag.id !== item.id
      })
    },
    removeTagsAll: function () {
      this.selids_beta = []
      this.seltags_beta = []
    },
    submit: function () {
      const data = {
        // isOpen: this.value.isOpen,
        selectedIds: this.selids_beta,
        selectedItems: this.seltags_beta,
        mode: this.value.mode
      }
      if (this.useSubmit) {
        data.isOpen = true // modalは閉じないでemit先に任せる
        this.$emit('submit', data)
      }
      else {
        data.isOpen = false // modalを閉じる
        this.$emit('input', data)
      }
    },
    getOutline: function (item) {
      return item.openflag === this.app_flag.OFF
    },
    selectColor: function (color) {
      this.pvTags.selected.color = color.id
      this.pvTags.selected.color_rgb = color.rgb
    },
    // 個人タグを追加する
    addPvTag: function () {
      this.clearMessages()
      if (!this.checkFormValidity()) return

      const vm = this

      // 登録内容
      let params = {
        name: this.pvTags.selected.name,
        color: this.pvTags.selected.color
      }

      PvtagRepository.post(params)
        .then(function (response) {
          let newTag = vm.getApiData(response).data
          // 追加したタグ情報の整形
          delete newTag.count_persons
          delete newTag.formatted_count_persons

          vm.selTag(newTag)
          vm.pvTags.selected.name = ''

          vm.getPvTagList({page: vm.pvTags.pagination.current_page})
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    initModal () {
      const vm = this

      // タグ一覧取得
      this.getMgTagList()

      // 個人タグ表示機能を付ける場合
      if (this.value.mode.isDispPv) {
        // 個人タグ一覧取得
        this.getPvTagList()
      }

      // 個人タグ追加機能を付ける場合
      if (this.value.mode.canAddPv) {
        // 初期データ取得
        PvtagRepository.getColors()
          .then(function (response) {
            vm.pvTags.colors = vm.getApiData(response).data.tag_colors
            // 初期選択肢の設定
            vm.selectColor(vm.pvTags.colors[0])
            // タグカラー表示用にプロパティを追加する
            for (let item of vm.pvTags.colors) {
              item.openflag = vm.app_flag.OFF
            }
          })
          .catch(function (error) {
            vm.setErrorMessage(error)
          })

        this.maxlengths = this.loadMaxlengths('Mgtags')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul.dropdown-menu {
  white-space: normal;
  width: 254px;
  margin: 0;
  padding: 0;

  li {
    padding: 10px;
    display: inline-block;
    cursor: pointer;

    &:hover {
      background-color: #e6e6e6;
    }

    &.active {
      background-color: lightblue;
    }
  }
}

// 2pane
.bcard .modal-dialog {
  .modal-body {
    #pvtags {
      .btn {
        height: 34px;
      }
    }
  }

  .modal-layout {
    height: auto;
    margin: 0 -15px -15px -15px;

    display: block;

    .nav.nav-tabs {
      padding-left: 15px;
    }

    .bcard-btnbar {
      position: relative;
      margin: 5px;

      .bcard-pagination {
        margin: 0;
      }

      > a {
        position: absolute;
        top: 50%;

        transform: translateY(-50%);
      }
    }

    .form-group {
      margin: 0 5px 5px 5px;
    }

    .table {
      margin-bottom: 0;

      td {
        line-height: 22px;

        span {
          margin-right: 5px;
        }
      }
    }

    .modal-list-divider {
      right: 0;
      left: 0;
      margin-left: 0;
    }
  }

  .modal-list-target {
    .table-responsive {
      height: 157px;
    }
  }
  .modal-list-selected {
    .table-responsive {
      height: 158px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalSelTag.vue